import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal"]

  static values = {
    storageKey: String,
    delay: { type: Number, default: 1600 },
  }

  connect() {
    if (!this.hasModalTarget) return

    this.modal = Modal.getOrCreateInstance(this.modalTarget)
    this.rememberShown = () => this.markShown()
    this.modalTarget.addEventListener("shown.bs.modal", this.rememberShown)

    if (!this.wasShown()) {
      this.openTimer = window.setTimeout(() => {
        this.modal.show()
      }, this.delayValue)
    }
  }

  disconnect() {
    if (this.openTimer) {
      window.clearTimeout(this.openTimer)
    }

    if (this.hasModalTarget && this.rememberShown) {
      this.modalTarget.removeEventListener("shown.bs.modal", this.rememberShown)
    }
  }

  wasShown() {
    try {
      return window.localStorage.getItem(this.storageKey()) === "shown"
    } catch (_error) {
      return false
    }
  }

  markShown() {
    try {
      window.localStorage.setItem(this.storageKey(), "shown")
    } catch (_error) {
      // If storage is unavailable, the modal still works for the current page.
    }
  }

  storageKey() {
    return this.hasStorageKeyValue
      ? this.storageKeyValue
      : "sample-request-modal"
  }
}
